export const EMPLOYEE_REQUEST = "EMPLOYEE_REQUEST";
export const EMPLOYEE_SUCCESS = "EMPLOYEE_SUCCESS";
export const EMPLOYEE_FAIL = "EMPLOYEE_FAIL";

export const EMPLOYEE_BY_ID_REQUEST = "EMPLOYEE_BY_ID_REQUEST";
export const EMPLOYEE_BY_ID_SUCCESS = "EMPLOYEE_BY_ID_SUCCESS";
export const EMPLOYEE_BY_ID_FAIL = "EMPLOYEE_BY_ID_FAIL";